var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndicador3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 48,
    viewBox: "0 0 111 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.02 47.2103C102.02 41.0369 100.804 34.9239 98.4413 29.2204C96.0789 23.5169 92.6162 18.3346 88.2509 13.9693C83.8856 9.60404 78.7033 6.14132 72.9998 3.77885C67.2963 1.41639 61.1833 0.200439 55.0099 0.200439C48.8365 0.20044 42.7235 1.41639 37.02 3.77885C31.3165 6.14132 26.1341 9.60404 21.7689 13.9693C17.4036 18.3346 13.9409 23.5169 11.5784 29.2204C9.21595 34.9239 8 41.0369 8 47.2103H26.804C26.804 43.5063 27.5335 39.8385 28.951 36.4164C30.3685 32.9943 32.4461 29.8849 35.0653 27.2657C37.6844 24.6466 40.7938 22.5689 44.2159 21.1514C47.638 19.734 51.3058 19.0044 55.0099 19.0044C58.7139 19.0044 62.3817 19.734 65.8038 21.1514C69.2259 22.5689 72.3353 24.6466 74.9545 27.2657C77.5736 29.8849 79.6513 32.9943 81.0688 36.4164C82.4862 39.8385 83.2158 43.5063 83.2158 47.2103H102.02Z",
    fill: "#C4C5CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 47.2103C8 38.7914 10.2609 30.5269 14.5465 23.2803C18.8321 16.0338 24.9851 10.0711 32.3627 6.01525L41.4216 22.4933C36.995 24.9268 33.3032 28.5044 30.7319 32.8523C28.1605 37.2003 26.804 42.1589 26.804 47.2103H8Z",
    fill: "#80F279"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0104 6.21091C39.3529 2.09195 47.6669 0.0204073 56.0836 0.212704C64.5004 0.405 72.7111 2.85408 79.8578 7.30407L69.9186 23.2666C65.6306 20.5966 60.7042 19.1271 55.6541 19.0117C50.6041 18.8964 45.6157 20.1393 41.2102 22.6107L32.0104 6.21091Z",
    fill: "#D12600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2662 40.5637L93.9707 27.1136L53.9448 45.6804L52.2662 40.5637Z",
    fill: "#797D8D",
    stroke: "#797D8D",
    strokeWidth: 0.718,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicador3);
export default __webpack_public_path__ + "static/media/Indicador3.d19cd89afb46416ddfd5ef3174202fa1.svg";
export { ForwardRef as ReactComponent };